import {
	getLogoOrImageConfig,
	richTextResolver,
} from "@website-builder/utilities-index";

export default (
	{ address = {}, logoConfig = null },
	{ basicConfig = {}, globalVariableWithURL = [] },
) => {
	const addressHtmlText = address.content
		? richTextResolver(address, globalVariableWithURL)
		: "";
	logoConfig = getLogoOrImageConfig(logoConfig, basicConfig);
	return {
		addressHtmlText,
		logoConfig,
	};
};
